import store from '@/store';
import checkTcNumber from '@/utils/check.tc.number';

/*eslint-disable */
const url = {
  validate: str => {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  },
  message: '{_field_} alanına geçerli bir url giriniz',  
}
/*eslint-enable */

const uniqueEmail = {
  validate: async value => {
    const isUse = await store.dispatch('management/checkEmailIsUse', {
      email: value,
    });
    return !isUse;
  },
  message: 'Sistemde kayıtlı böyle bir e-posta adresi mevcut.',
};

const uniqueSupplierApplicationemail = {
  validate: async value => {
    const isUse = await store.dispatch('supplier/checkEmailIsUse', {
      email: value,
    });
    return !isUse;
  },
  message: 'Bu e-posta adresi ile daha önce yapılmış bir başvuru var.',
};

const uniqueSellerApplicationemail = {
  validate: async value => {
    const isUse = await store.dispatch('seller/checkEmailIsUse', {
      email: value,
    });
    return !isUse;
  },
  message: 'Bu e-posta adresi ile daha önce yapılmış bir başvuru var.',
};

const uniqueCarrierApplicationemail = {
  validate: async value => {
    const isUse = await store.dispatch('carrier/checkEmailIsUse', {
      email: value,
    });
    return !isUse;
  },
  message: 'Bu e-posta adresi ile daha önce yapılmış bir başvuru var.',
};

const withoutEmoji = {
  validate: str => {
    const pattern = new RegExp(
      '([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])'
    );
    return !pattern.test(str);
  },
  message: '{_field_} alanına emoji karakterleri giremezsiniz',
};

const tcNumber = {
  validate: str => {
    return checkTcNumber(str);
  },
  message: '{_field_} alanına geçerli bir TC Kimlik numarası giriniz',
};

const tin = {
  validate: str => {
    return !!new RegExp('^[0-9]{10}$').test(str);
  },
  message: '{_field_} alanına geçerli bir Vergi Kimlik numarası giriniz',
};

const tinOrTcNumber = {
  validate: str => {
    if (str.length === 11 && !checkTcNumber(str)) {
      return '{_field_} alanına geçerli bir TC Kimlik numarası giriniz';
    } else {
      return true;
    }
  },
};

export {
  url,
  uniqueEmail,
  uniqueSupplierApplicationemail,
  uniqueSellerApplicationemail,
  uniqueCarrierApplicationemail,
  withoutEmoji,
  tcNumber,
  tin,
  tinOrTcNumber,
};
